import React, {Component} from 'react';
import useFeatureFlag from "../../hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "../../constants/configurationKeys";
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import AdvancedDisbursementsForm from "../../components/AdvancedDisbursements/advancedDisbursementsForm";
import {
    addAdAttachment, changeAdFormData, changeAdFormSettings,
    removeAdFormAttachment
} from "../../actions/advancedDisbursementsForm";
import {
    createAdvancedDisbursement, editAdvancedDisbursement, getAdvanceDisbursementsStatuses,getAdvanceDisbursementsRejectionReasons,
    getApplicationAdUpdateStatus
} from "../../actions/advancedDisbursements";
import _ from 'lodash';
import {getExpenseTypes} from "../../actions/expenseTypes";
import {getGroupExpensesCaseTypes} from "../../actions/groups";
import {requestApplicationDamages} from "../../actions/premiumSettings";
import {
    _getFileFromBase64,
    isAragUser,
    isSolicitorUser
} from "../../helpers/functions";
// import download from "in-browser-download";
import {getAllowedADTransitionsmachineNames} from "../../components/AdvancedDisbursements/utlis/functions";
import {checkCasesSubCasesBetweenUserAndApplicationForm} from "../../helpers/advanceDisbursments/disableADButtons";

const LIKELY_CLAIMS_TRACK_QUESTION_MACHINE_NAME = 'LikelyClaimsTrack';

class AdvancedDisbursementsFormHOC extends Component {

    componentWillReceiveProps(nextProps) {
        // Once the application (and therefore its claims track) has loaded, fetch the
        // damages bands valid for that track.
        if (this.props.fetchingApplicationPolicy && !nextProps.fetchingApplicationPolicy && nextProps.applicationId) {
            this.props.getDamages(nextProps.applicationId);
        }
        // (Re)compute the preselected band once both the application answers and the
        // track-scoped damages list are available (either can arrive last).
        const damagesJustArrived = (!this.props.damages || !this.props.damages.length)
            && nextProps.damages && nextProps.damages.length;
        const answersJustArrived = !this.props.applicationAnswersDtos && nextProps.applicationAnswersDtos;
        if ((damagesJustArrived || answersJustArrived) && nextProps.applicationAnswersDtos) {
            this.props.changeAdFormData('damageRange', this._getApplicationDamageId(nextProps.applicationAnswersDtos, nextProps.damages))
        }
    }

    componentDidMount() {
        if (this.props.solicitorGroupId) {
            this.props.getGroupExpensesCaseTypes(this.props.solicitorGroupId);
        }
        if (this.props.applicationAnswersDtos) {
            this.props.changeAdFormData('damageRange', this._getApplicationDamageId(this.props.applicationAnswersDtos, this.props.damages))
        }
        if (
            !this.props.isAragUser
            && !this.props.editingForm
            && this.props.applicationId
        ) {
            this.props.getApplicationAdUpdateStatus(this.props.applicationId);
        }
        if (this.props.isAragUser) {
            this.props.getAdvanceDisbursementsStatuses();
            this.props.getAdvanceDisbursementsRejectionReasons();
        }
        if (this.props.applicationId) {
            this.props.getDamages(this.props.applicationId);
        }
        this.props.getAllExpenseTypes();
    }

    _handleNumberInputChange = (name, value) => {
        this.props.changeAdFormData(name, value);
    };

    _handleSelectInputChange = (evt) => {
        this.props.changeAdFormData(evt.target.name, evt.target.value);
    };

    _handleTextInputChange = (name, value) => {
        this.props.changeAdFormData(name, value);
    };

    _validateForm = () => {
        if (
            !_.isNumber(parseFloat(this.props.advancedDisbursementsForm.formData.amount))
            && !this.props.advancedDisbursementsForm.formData.canceled
        ) {
            this.props.changeAdFormSettings('failedResponseMsg', 'Invalid amount, please type a number.');
            return false;
        }
        if (
            parseFloat(this.props.advancedDisbursementsForm.formData.amount) === 0
            && !this.props.advancedDisbursementsForm.formData.canceled
        ) {
            this.props.changeAdFormSettings('failedResponseMsg', 'Please add an amount.');
            return false;
        }
        if (
            this._isCourtFeesAd()
            && !this.props.advancedDisbursementsForm.formData.damageRange
            && !this.props.advancedDisbursementsForm.formData.canceled
        ) {
            this.props.changeAdFormSettings('failedResponseMsg', 'Please select a damage range.');
            return false;
        }
        if (
            this.props.advancedDisbursementsForm.formData.attachments.length === 0
            && !this.props.advancedDisbursementsForm.formData.canceled
        ) {
            this.props.changeAdFormSettings('failedResponseMsg', 'Please upload at least one attachment.');
            return false;
        }
        return true;
    };

    _handleSubmit = (evt) => {
        evt.preventDefault();
        if (this.props.fetchingApplicationPolicy) return false;
        let isvalidForm = this._validateForm();
        if (!isvalidForm) {
            return 0;
        }
        this.props.createAdvancedDisbursement({
            amount: this.props.advancedDisbursementsForm.formData.amount,
            expenseTypeId: this.props.advancedDisbursementsForm.formData.disbursementsType,
            applicationId: this.props.applicationId,
            damagesId: this._isCourtFeesAd() ? this.props.advancedDisbursementsForm.formData.damageRange : null,
            attatchmentDtos: this.props.advancedDisbursementsForm.formData.attachments.length > 0 ?
                this.props.advancedDisbursementsForm.formData.attachments : null
        })
    };

    _getDisbursementTypesOptions = () => {
        let options = [];
        let expenseCaseType = _.find(this.props.groupExpenseCaseTypes, e => {
            return e.id === this.props.applicationCaseTypeId
        });
        if (!expenseCaseType) {
            return []
        }
        options = expenseCaseType.expenseTypeDtos.map(dT => {
            return {key: dT.id, value: dT.name}
        });
        options.unshift({key: '', value: ''});
        return options;
    };

    _getDamageOptions = () => {
        let a = this.props.damages.map(d => ({
            key: d.id,
            value: d.range
        }));
        a.unshift({key: '', value: ''});
        return a;
    };

    _setDamageRange = (evt) => {
        this.props.changeAdFormData(evt.target.name, evt.target.value);
    };

    mapADIdToExpenseType = (ADId) => {
        try {
            const foundItem = this.props.expenseTypes.find(type => type.id.toString() === ADId.toString());
            if (foundItem) {
                return foundItem;
            }

            return {};
        } catch (e) {
            return {};
        }
    };

    _isCourtFeesAd = () => {
        const expenseType = this.mapADIdToExpenseType(this.props.advancedDisbursementsForm.formData.disbursementsType);
        return expenseType.machineName === "courtFees";
    };

    _isMedicalFees = () => {
        const expenseType = this.mapADIdToExpenseType(this.props.advancedDisbursementsForm.formData.disbursementsType);
        return expenseType.machineName === "medicalFees";
    };

    _onDrop = (files) => { //onChange handler for the drop zone component that adds attachments
        for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
            let alreadyExists = false;
            for (let attachmentIndex = 0; attachmentIndex < this.props.advancedDisbursementsForm.formData.attachments.length; attachmentIndex++) {
                if (files[fileIndex].name === this.props.advancedDisbursementsForm.formData.attachments[attachmentIndex].name) {
                    alreadyExists = true
                }
            }
            if (!alreadyExists) {
                this._getBase64(files[fileIndex])
            } else {
                // console.log('=====already exists =======')
            }
        }
    };

    //function that transforms the input file to base64 format
    _getBase64 = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let attachment = {
            name: file.name,
            encodedFile: '',
            fileType: file.type
        };
        let props = this.props;
        reader.onload = function () {
            attachment = {...attachment, encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)};
            props.addAdAttachment(attachment);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    // The damages question machine names aren't fixed - they're whatever the
    // LikelyClaimsTrack question's options point to via their childQuestions
    // (Fast Track -> FastTrackDamages, Multi Track -> MultiTrackDamages, etc). Deriving
    // them from that same graph (already sent to the frontend as part of `questions`)
    // means this never drifts from the backend's AppConstants.DAMAGES_QUESTION_MACHINE_NAMES,
    // and a new/removed track needs no frontend change at all.
    _getDamagesQuestionMachineNames = () => {
        const trackQuestion = _.find(this.props.questions, q => q.machineName === LIKELY_CLAIMS_TRACK_QUESTION_MACHINE_NAME);
        if (!trackQuestion || !trackQuestion.options) {
            return [];
        }
        return _.flatMap(trackQuestion.options, option => (option.childQuestions || []).map(cq => cq.machineName))
            .filter(Boolean);
    };

    _getApplicationDamageId = (applicationAnswersDtos, damages = this.props.damages) => {
        let damageId = '';
        let optionMachineName = '';
        if (!applicationAnswersDtos) {
            return damageId;
        }
        const damagesQuestionMachineNames = this._getDamagesQuestionMachineNames();
        _.forEach(applicationAnswersDtos, a => {
            if (a.questionMachineName && damagesQuestionMachineNames.includes(a.questionMachineName)) {
                optionMachineName = a.optionMachineName;
                return false;
            }
        });
        _.forEach(damages, d => {
            if (d.range === optionMachineName) {
                damageId = d.id;
                return false;
            }
        });
        return damageId;
    };

    _canApplyBasedOnApplicationPolicy = () => {
        if (!this.props.applicationId) return false;
        if (!this.props.applicationCaseTypeId) return false;
        let GroupExpenseType = _.find(this.props.groupExpenseCaseTypes, e => e.id === this.props.applicationCaseTypeId);
        if (!GroupExpenseType) return false;
        else return true;
    };

    _handleCheckboxChange = (evt) => {
        this.props.changeAdFormData(evt.target.name, evt.target.checked)
    };

    _getAdvanceDisbursementsStatusOptions = () => {
        const allowedTransitionsMachineNames = getAllowedADTransitionsmachineNames(
            this.props.advancedDisbursementsForm.adRequest
        );
        const transitionsForCurrentADStatus = allowedTransitionsMachineNames[
            this.props.advancedDisbursementsForm.adRequest.disbursementStatusMachineName
            ];

        let o = this.props.advanceDisbursementsStatuses
            .map(i => ({
                key: i.machineName,
                value: i.name
            }))
            .filter(status => transitionsForCurrentADStatus ?
                (
                    transitionsForCurrentADStatus.includes(status.key)
                    || status.key === this.props.advancedDisbursementsForm.adRequest.disbursementStatusMachineName
                ) : false
            );
        o.unshift({key: '', value: ''});
        return o;
    };

    _getExpenseTypeName = (expenseTypeId) => {
        let expType = _.find(this.props.expenseTypes, e => {
            return e.id === parseInt(expenseTypeId)
        });
        if (expType) {
            return expType.name
        } else return '';
    };

    _getSubmitButtonLabel = () => {
        if (this.props.isAragUser) {
            return 'Change status'
        }
        if (this.props.isSolicitorUser) {
            if (this.props.editingForm) {
                return 'Update';
            }
            return 'Create';
        }
    };

    _getSubmitHandler = () => {
        if (this.props.isAragUser) {
            return this._submitNewAdStatus
        }
        if (this.props.isSolicitorUser) {
            if (this.props.editingForm) {
                return this._updateForm;
            }
            return this._handleSubmit;
        }
    };

    _updateForm = (evt) => {
        evt.preventDefault();
        if (this.props.fetchingApplicationPolicy) return false;
        let isvalidForm = this._validateForm();
        if (!isvalidForm) {
            return 0;
        }
        this.props.editAdvancedDisbursement({
            id: this.props.advancedDisbursementsForm.formData.id,
            sendBody: {
                id: this.props.advancedDisbursementsForm.formData.id,
                canceled: this.props.advancedDisbursementsForm.formData.canceled,
                amount: this.props.advancedDisbursementsForm.formData.amount,
                expenseTypeId: this.props.advancedDisbursementsForm.formData.disbursementsType,
                applicationId: this.props.applicationId,
                damagesId: this._isCourtFeesAd() ? this.props.advancedDisbursementsForm.formData.damageRange : null,
                attatchmentDtos: this._isMedicalFees() ? this.props.advancedDisbursementsForm.formData.attachments : null
            }
        })
    };

    _submitNewAdStatus = (evt) => {
        evt.preventDefault();
        this.props.editAdvancedDisbursement({
            id: this.props.advancedDisbursementsForm.formData.id,
            sendBody: {
                id: this.props.advancedDisbursementsForm.formData.id,
                disbursementStatusMachineName: this.props.advancedDisbursementsForm.formData.status,
                rejectionReasonMachineName:this.props.advancedDisbursementsForm.formData.rejectionReason,
                rejectionReasonDetails:this.props.advancedDisbursementsForm.formData.status == 'rejected' && this.props.advancedDisbursementsForm.formData.rejectionReason == 'Other' ? this.props.advancedDisbursementsForm.formData.rejectionReasonDetails : null
            }
        })
    };

    _canCancelAd = () => {
        let statusMachineName = this.props.advancedDisbursementsForm.formData.status;
        if (
            this.props.isSolicitorUser
            && (statusMachineName === 'applied' || statusMachineName === 'approved')
            && !this.props.advancedDisbursementsForm.formData.paymentInstructionId
        ) {
            return !checkCasesSubCasesBetweenUserAndApplicationForm({
                user: this.props.loggingInUser,
                applicationCaseTypeId: this.props.applicationCaseTypeId,
                applicationSubCaseTypeId: this.props.applicationSubCaseTypeId
            })
        }
        return false;
    };

    _canEdit = () => {
        let statusMachineName = this.props.advancedDisbursementsForm.formData.status;
        if (this.props.isSolicitorUser){
            if(!this.props.editingForm || (this.props.editingForm && statusMachineName === 'applied')){
                return !checkCasesSubCasesBetweenUserAndApplicationForm({
                    user: this.props.loggingInUser,
                    applicationCaseTypeId: this.props.applicationCaseTypeId,
                    applicationSubCaseTypeId: this.props.applicationSubCaseTypeId
                })
            }
        }
        else{
            if (this.props.editingForm && statusMachineName === 'applied') {
                return true;
            }
        }

        return false;
    };

    // _getFileFromBase64 = (documentToDownload) => {
    //     _getFileFromBase64(documentToDownload);
    //     // download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    // };

    formWasUpdated = () => {
        if (
            this.props.editingForm
            && this.props.isAragUser
            && this.props.advancedDisbursementsForm.adRequest
            && this.props.advancedDisbursementsForm.formData
            && (this.props.advancedDisbursementsForm.adRequest.disbursementStatusMachineName === this.props.advancedDisbursementsForm.formData.status
            && (this.props.advancedDisbursementsForm.adRequest.rejectionReasonMachineName === this.props.advancedDisbursementsForm.formData.rejectionReason)
            && (this.props.advancedDisbursementsForm.adRequest.rejectionReasonDetails === this.props.advancedDisbursementsForm.formData.rejectionReasonDetails))
        ) {
            return false;
        }

        if (
            this.props.editingForm
            && this.props.isAragUser
            && (
                (this.props.advancedDisbursementsForm.formData.status == "rejected" && !this.props.advancedDisbursementsForm.formData.rejectionReason)
                ||
                (this.props.advancedDisbursementsForm.formData.rejectionReason == "Other" && !this.props.advancedDisbursementsForm.formData.rejectionReasonDetails))
            ){
                return false;
            }

        if (
            this.props.isSolicitorUser
            && this.props.advancedDisbursementsForm.adRequest
            && this.props.advancedDisbursementsForm.formData
            && (
                this.props.advancedDisbursementsForm.adRequest.expenseTypeId
                && this.props.advancedDisbursementsForm.formData.disbursementsType
                && this.props.advancedDisbursementsForm.adRequest.expenseTypeId.toString() === this.props.advancedDisbursementsForm.formData.disbursementsType.toString()
            )
            && parseFloat(this.props.advancedDisbursementsForm.adRequest.amount) === parseFloat(this.props.advancedDisbursementsForm.formData.amount)
            && (
                this.props.advancedDisbursementsForm.adRequest.damagesId
                && this.props.advancedDisbursementsForm.formData.damageRange
                && this.props.advancedDisbursementsForm.adRequest.damagesId.toString() === this.props.advancedDisbursementsForm.formData.damageRange.toString()
            )
            && this.props.advancedDisbursementsForm.adRequest.canceled === this.props.advancedDisbursementsForm.formData.canceled
            && this.props.advancedDisbursementsForm.adRequest.attatchmentDtos.length === this.props.advancedDisbursementsForm.formData.attachments.length
            && this.props.advancedDisbursementsForm.formData.attachments.length > 0
            && this.props.advancedDisbursementsForm.adRequest.attatchmentDtos
                .filter(attachmentDto => this.props.advancedDisbursementsForm.formData.attachments
                    .find(formAttachment => formAttachment.id !== attachmentDto.id)
                )
                .length === 0
        ) {
            return false
        }

        return true;
    };

    render() {
        return (
            <AdvancedDisbursementsForm
                editingForm={this.props.editingForm}
                formWasUpdated={this.formWasUpdated}
                fetchingApplicationPolicy={this.props.fetchingApplicationPolicy}
                fetchingAdById={this.props.fetchingAdById}
                _getFileFromBase64={_getFileFromBase64}
                canEdit={this._canEdit()}
                patchingAdvanceDisbursement={this.props.patchingAdvanceDisbursement}
                submitButtonLabel={this._getSubmitButtonLabel()}
                _getExpenseTypeName={this._getExpenseTypeName}
                canCancelAd={this._canCancelAd()}
                advanceDisbursementsStatusOptions={this._getAdvanceDisbursementsStatusOptions()}
                advanceDisbursementsRejectionReasonsOptions={this.props.advanceDisbursementsRejectionReasons}
                _handleCheckboxChange={this._handleCheckboxChange}
                isAragUser={this.props.isAragUser}
                isSolicitorUser={this.props.isSolicitorUser}
                canApplyBasedOnApplicationPolicy={this._canApplyBasedOnApplicationPolicy()}
                applicationId={this.props.applicationId}
                userRole={this.props.userRole}
                shouldUpdate={this.props.shouldUpdate}
                fetchingUpdateStatus={this.props.fetchingUpdateStatus}
                _removeAdFormAttachment={this.props.removeAdFormAttachment}
                _onDrop={this._onDrop}
                isCourtFeesAd={this._isCourtFeesAd()}
                _setDamageRange={this._setDamageRange}
                damageOptions={this._getDamageOptions()}
                _cancel={this.props.cancel}
                disbursementTypesOptions={this._getDisbursementTypesOptions()}
                postingAdvancedDisbursement={this.props.postingAdvancedDisbursement}
                _handeSubmit={this._getSubmitHandler()}
                _handleSelectInputChange={this._handleSelectInputChange}
                _handleNumberInputChange={this._handleNumberInputChange}
                _handleTextInputChange={this._handleTextInputChange}
                formData={this.props.advancedDisbursementsForm.formData}
                failedResponseMsg={this.props.advancedDisbursementsForm.failedResponseMsg}
                successResponseMsg={this.props.advancedDisbursementsForm.successResponseMsg}
                fetchedAD={this.props.advancedDisbursementsForm.adRequest}
                mapADIdToExpenseType={this.mapADIdToExpenseType}

            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fetchingAdById: state.advancedDisbursements.fetchingById,
        patchingAdvanceDisbursement: state.advancedDisbursements.patching,
        advanceDisbursementsStatuses: state.advancedDisbursements.advanceDisbursementsStatuses,
        advanceDisbursementsRejectionReasons: state.advancedDisbursements.advanceDisbursementsRejectionReasons,
        userRole: state.user.loggedInUser.roles[0] ? state.user.loggedInUser.roles[0] : '',
        shouldUpdate: state.advancedDisbursements.shouldUpdate,
        fetchingUpdateStatus: state.advancedDisbursements.fetchingUpdateStatus,
        applicationAnswersDtos: state.newApplication.selectedApplication.applicationAnswersDtos,
        questions: state.newApplication.questions,
        damages: state.damages.applicationDamages,
        fetchingDamages: state.damages.fetchingDamages,
        advancedDisbursementsForm: state.advancedDisbursementsForm,
        postingAdvancedDisbursement: state.advancedDisbursements.posting,
        expenseTypes: state.expenseTypes.expenseTypes,
        solicitorGroupId: state.user.loggedInUser.solicitorGroupId ? state.user.loggedInUser.solicitorGroupId : '',
        groupExpenseCaseTypes: state.groups.groupExpenseCaseTypes,
        applicationCaseTypeId: state.newApplication.selectedApplication.caseTypeId ? state.newApplication.selectedApplication.caseTypeId : null,
        applicationSubCaseTypeId: state.newApplication.selectedApplication.subCaseTypeId ? state.newApplication.selectedApplication.subCaseTypeId : null,
        applicationId: state.newApplication.selectedApplication.id ? state.newApplication.selectedApplication.id : '',
        fetchingApplicationPolicy: state.newApplication.fetching,
        isAragUser: isAragUser(state.user.loggedInUser.roles),
        isSolicitorUser: isSolicitorUser(state.user.loggedInUser.roles),
        loggingInUser: state.user.loggedInUser,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeAdFormData: (key, value) => {
            dispatch(changeAdFormData(key, value))
        },
        changeAdFormSettings: (key, value) => {
            dispatch(changeAdFormSettings(key, value))
        },
        createAdvancedDisbursement: (advancedDisbursement) => {
            dispatch(createAdvancedDisbursement(advancedDisbursement))
        },
        getGroupExpensesCaseTypes: (payload) => {
            dispatch(getGroupExpensesCaseTypes(payload))
        },
        getDamages: (applicationId) => {
            dispatch(requestApplicationDamages(applicationId))
        },
        getAllExpenseTypes: () => {
            dispatch(getExpenseTypes())
        },
        addAdAttachment: (payload) => {
            dispatch(addAdAttachment(payload))
        },
        removeAdFormAttachment: (payload) => {
            dispatch(removeAdFormAttachment(payload))
        },
        getApplicationAdUpdateStatus: (payload) => {
            dispatch(getApplicationAdUpdateStatus(payload))
        },
        getAdvanceDisbursementsStatuses: () => {
            dispatch(getAdvanceDisbursementsStatuses())
        },
        getAdvanceDisbursementsRejectionReasons: () => {
            dispatch(getAdvanceDisbursementsRejectionReasons())
        },
        editAdvancedDisbursement: (payload) => {
            dispatch(editAdvancedDisbursement(payload))
        }
    }
};

const ConnectedAdvancedDisbursementsFormHOC = connect(mapStateToProps, mapDispatchToProps)(AdvancedDisbursementsFormHOC);

const AdvancedDisbursementsFormHOCWithFeatureFlag = (props) => {
    const advanceDisbursementsEnabled = useFeatureFlag(FEATURE_FLAGS.ADVANCE_DISBURSEMENTS_ENABLED);
    if (!advanceDisbursementsEnabled) return <Redirect to="/" />;
    return <ConnectedAdvancedDisbursementsFormHOC {...props} />;
};

export default AdvancedDisbursementsFormHOCWithFeatureFlag;
